const api = process.env.REACT_APP_API || '';

const config = {
  apiUrl: api.endsWith('/')
    ? api.slice(0, -1)
    : api,
  guestToken: process.env.REACT_APP_GUEST_TOKEN,
  currencySiteMainId: process.env.REACT_APP_CURRENCY_MAIN_ID,
  lang: process.env.REACT_APP_LANG,
  catalogUrl: process.env.REACT_APP_CATALOG_URL,
};

// const config = {
//   apiUrl:
//     'https://api.daniparts.com/'['https://api.daniparts.com/'.length - 1] ===
//     '/'
//       ? 'https://api.daniparts.com/'.slice(0, -1)
//       : 'https://api.daniparts.com/',
//   guestToken: 'cf1a6793f669327a0417fbfed80e574f2ad8d26c',
//   currencySiteMainId: '3',
//   lang: 'UA',
//   catalogUrl: 'product-groups',
// };

export default config;
